import { IPagination } from 'app/types/common';

export interface ICreditCardsState {
  readonly creditCardsById?: any;
  readonly creditCardIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly creditCardToken?: string;
  readonly showAddCreditCard?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationCreditCardIds?: string[];
  readonly currentCreditCardId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface ICreditCardsSelector extends ICreditCardsState {
  readonly currentCreditCard?: any;
  readonly currentFormCreditCard?: any;
  readonly getCreditCardsFilteredByTagInSelectFormat?: any;
  readonly creditCardsByIdInSelectFormat?: any;
}

export enum CreditCardsActionTypes {
  GET_ALL_CREDIT_CARDS_REQUESTED = 'redux-app/credit-cards/GET_ALL_CREDIT_CARDS_REQUESTED',
  GET_ALL_CREDIT_CARDS_PENDING = 'redux-app/credit-cards/GET_ALL_CREDIT_CARDS_PENDING',
  GET_ALL_CREDIT_CARDS_SUCCESS = 'redux-app/credit-cards/GET_ALL_CREDIT_CARDS_SUCCESS',
  GET_ALL_CREDIT_CARDS_FAIL = 'redux-app/credit-cards/GET_ALL_CREDIT_CARDS_FAIL',
  GET_CREDIT_CARD_REQUESTED = 'redux-app/credit-cards/GET_CREDIT_CARD_REQUESTED',
  GET_CREDIT_CARD_PENDING = 'redux-app/credit-cards/GET_CREDIT_CARD_PENDING',
  GET_CREDIT_CARD_SUCCESS = 'redux-app/credit-cards/GET_CREDIT_CARD_SUCCESS',
  GET_CREDIT_CARD_FAIL = 'redux-app/credit-cards/GET_CREDIT_CARD_FAIL',
  UPDATE_CREDIT_CARD_REQUESTED = 'redux-app/credit-cards/UPDATE_CREDIT_CARD_REQUESTED',
  UPDATE_CREDIT_CARD_PENDING = 'redux-app/credit-cards/UPDATE_CREDIT_CARD_PENDING',
  UPDATE_CREDIT_CARD_SUCCESS = 'redux-app/credit-cards/UPDATE_CREDIT_CARD_SUCCESS',
  UPDATE_CREDIT_CARD_FAIL = 'redux-app/credit-cards/UPDATE_CREDIT_CARD_FAIL',
  CREATE_CREDIT_CARD_REQUESTED = 'redux-app/credit-cards/CREATE_CREDIT_CARD_REQUESTED',
  CREATE_CREDIT_CARD_PENDING = 'redux-app/credit-cards/CREATE_CREDIT_CARD_PENDING',
  CREATE_CREDIT_CARD_SUCCESS = 'redux-app/credit-cards/CREATE_CREDIT_CARD_SUCCESS',
  CREATE_CREDIT_CARD_FAIL = 'redux-app/credit-cards/CREATE_CREDIT_CARD_FAIL',
  DELETE_CREDIT_CARD_REQUESTED = 'redux-app/credit-cards/DELETE_CREDIT_CARD_REQUESTED',
  DELETE_CREDIT_CARD_PENDING = 'redux-app/credit-cards/DELETE_CREDIT_CARD_PENDING',
  DELETE_CREDIT_CARD_SUCCESS = 'redux-app/credit-cards/DELETE_CREDIT_CARD_SUCCESS',
  DELETE_CREDIT_CARD_FAIL = 'redux-app/credit-cards/DELETE_CREDIT_CARD_FAIL',
  CREATE_CREDIT_CARD_TOKEN_REQUESTED = 'redux-app/credit-cards/CREATE_CREDIT_CARD_TOKEN_REQUESTED',
  CREATE_CREDIT_CARD_TOKEN_PENDING = 'redux-app/credit-cards/CREATE_CREDIT_CARD_TOKEN_PENDING',
  CREATE_CREDIT_CARD_TOKEN_SUCCESS = 'redux-app/credit-cards/CREATE_CREDIT_CARD_TOKEN_SUCCESS',
  CREATE_CREDIT_CARD_TOKEN_FAIL = 'redux-app/credit-cards/CREATE_CREDIT_CARD_TOKEN_FAIL',
  SELECT_CREDIT_CARD_REQUESTED = 'redux-app/credit-cards/SELECT_CREDIT_CARD_REQUESTED',
}

export default null;
